import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import { SvgAsset } from '@ingenico/react-ui/svg-asset';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './EmptyConfiguration.module.scss';

export function EmptyConfiguration(): ReactElement {
  const { t } = useTranslation(ALL_LNGS_NAMESPACES.CONFIGURATION_PROFILE);
  const title = t('empty.configurations.title');

  return (
    <div className={styles.host}>
      <CoreTypography customClassName={styles.title} variant={CoreTypographyVariant.Title01Bold}>
        {title}
      </CoreTypography>
      <SvgAsset className={styles.svg} image="merchant-illustration" />
    </div>
  );
}
